import {gql} from 'apollo-angular';
import {ImageFragment} from "./fragments/Image";

export const GET_GLOBAL_SEARCH_RESULTS = gql`
  query GetGlobalSearchResults ($search: String!) {
    globalSearch(search: $search) {
      jobs {
        id
        bicID
        name
        image {
          ...imageFields
        }
        description
        jobEducationalPaths {
          bicID
        }
        jobWorkFields {
          bicID
          name
        }
      }
      profiles {
        id
        uuid
        name
        profileType {
          id
        }
        picture {
          ...imageFields
        }
      }
      jobMarkets {
        id
        name
        description
        image {
          ...imageFields
        }
        positionType
      }
      stories {
        id
        image {
          ...imageFields
        }
        title
        portrait
      }
    }
  }
  ${ImageFragment}
`;
